import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, PurchaseContractsReducer, PurchaseContractsState, initialState } from './purchase-contracts-reducer';

const PurchaseContractsContext = createContext<PurchaseContractsState | undefined>(undefined);
const PurchaseContractsContextDispatchContext = createContext({} as any);

const PurchaseContractsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PurchaseContractsReducer, initialState);

    return (
        <PurchaseContractsContext.Provider value={state}>
            <PurchaseContractsContextDispatchContext.Provider value={dispatch}>
                {children}
            </PurchaseContractsContextDispatchContext.Provider>
        </PurchaseContractsContext.Provider>
    );
}

const usePurchaseContractsState = () => {
    const context = useContext(PurchaseContractsContext);
    if (context === undefined) {
        throw new Error('usePurchaseContractsState must be used within a PurchaseContractsProvider');
    }
    return context;
}

const usePurchaseContractsDispatch = () => {
    const context = useContext(PurchaseContractsContextDispatchContext);
    if (context === undefined) {
        throw new Error('usePurchaseContractsDispatch must be used within a PurchaseContractsProvider');
    }
    return context;
}

export { PurchaseContractsProvider, usePurchaseContractsState, usePurchaseContractsDispatch, ACTION_TYPES };
